import useCustomizerStore from "../../state/customizer";
import ToyotaCrown from "../webgl/Car/ToyotaCrown";
import PowertrainLights from "../webgl/SpotLight";

export default function ToyotaCrownShowroomModel({
  modelOverride,
  roomLighting,
  carOnly = false,
  powertrain = false,
  xOffset = 0,
  floorOffset = -0.95,
  depthOffset = -1.25,
}) {
  const selectedModel = useCustomizerStore((state) => state.model);
  const model = modelOverride ?? selectedModel;

  return (
    <group name="showroom-car">
      <group
        key={`showroom-model-${model}`}
        position={[xOffset, floorOffset, depthOffset]}
        rotation={[0, Math.PI * 1.5, 0]}
      >
        <ToyotaCrown modelIndex={model} displayModeOverride={powertrain ? "powertrain" : "exterior"} xrLighting carOnly={carOnly} roomLighting={roomLighting} />
        {powertrain && !carOnly && <PowertrainLights displayModeOverride="powertrain" />}
      </group>
    </group>
  );
}
